/**
 * §27.2 card 2, "Joining". Mounted as `children` of the `joining` slot
 * (`plan.md ## 5.19`). This component deliberately renders no card shell of
 * its own: `PoolSettingsCardSlot` owns the shell, the title, the tone and
 * the danger spacing, so nine other content owners inherit one shell rather
 * than each re-deciding it.
 */
import type { ReactNode } from "react";

import type { typeJoiningPoolInput } from "./joiningCardState";
import { PoolSettingsJoinCodeBlock } from "./PoolSettingsJoinCodeBlock";
import { PoolSettingsJoiningToggles } from "./PoolSettingsJoiningToggles";

export type typePoolSettingsJoiningCardProps = {
  poolId: string;
  pool: typeJoiningPoolInput;
  isPoolLoading: boolean;
};

export const PoolSettingsJoiningCard = ({
  poolId,
  pool,
  isPoolLoading,
}: typePoolSettingsJoiningCardProps): ReactNode => {
  return (
    <div
      className="flex flex-col gap-4"
      data-testid="pool-settings-joining-card"
    >
      <PoolSettingsJoiningToggles
        poolId={poolId}
        pool={pool}
        isPoolLoading={isPoolLoading}
      />
      <PoolSettingsJoinCodeBlock
        poolId={poolId}
        poolRefId={pool.poolRefId ?? null}
        poolName={pool.name ?? "your pool"}
      />
    </div>
  );
};
